import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _excluded = ["parent"];
import React, { forwardRef, useContext, useImperativeHandle, useMemo } from 'react';
import Checker from './Checker';
import CheckBoxContext from './CheckboxContext';
import useMergedState from '../hooks/use-merged-state';
import ConfigProviderContext from '../config-provider/ConfigProviderContext';
var CheckBox = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useContext = useContext(ConfigProviderContext),
      prefixCls = _useContext.prefixCls,
      createNamespace = _useContext.createNamespace;

  var _createNamespace = createNamespace('checkbox', prefixCls),
      _createNamespace2 = _slicedToArray(_createNamespace, 1),
      bem = _createNamespace2[0];

  var _useContext2 = useContext(CheckBoxContext),
      parent = _useContext2.parent,
      context = _objectWithoutProperties(_useContext2, _excluded);

  var _useMergedState = useMergedState({
    value: props.checked,
    defaultValue: props.defaultChecked
  }),
      _useMergedState2 = _slicedToArray(_useMergedState, 2),
      checked = _useMergedState2[0],
      setChecked = _useMergedState2[1];

  var setParentValue = function setParentValue(isChecked) {
    var name = props.name;
    var max = parent.props.max;
    var value = context.checked.slice();

    if (isChecked) {
      var overlimit = max && value.length >= max;

      if (!overlimit && value.indexOf(name) === -1) {
        value.push(name);

        if (props.bindGroup) {
          context.toggle(value);
        }
      }
    } else {
      var index = value.indexOf(name);

      if (index !== -1) {
        value.splice(index, 1);

        if (props.bindGroup) {
          context.toggle(value);
        }
      }
    }
  };

  var isChecked = useMemo(function () {
    if (parent && props.bindGroup) {
      return context.checked.indexOf(props.name) !== -1;
    }

    return checked;
  }, [context.checked, checked]);

  var toggle = function toggle() {
    var newValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !isChecked;

    if (parent && props.bindGroup) {
      setParentValue(newValue);
    } else {
      var _props$onChange;

      setChecked(newValue);
      (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, newValue);
    }
  };

  useImperativeHandle(ref, function () {
    return {
      toggle: toggle,
      checked: isChecked,
      props: props
    };
  });
  return /*#__PURE__*/React.createElement(Checker, _extends({}, props, {
    bem: bem,
    role: "checkbox",
    parent: parent,
    checked: isChecked,
    className: props.className,
    bindGroup: props.bindGroup,
    onToggle: toggle
  }));
});
CheckBox.displayName = 'Checkbox';
CheckBox.defaultProps = {
  bindGroup: true
};
export default CheckBox;